import { addresses } from '../constants';

const checkIsExchange = address => address === process.env.REACT_APP_EXCHANGE_ADDRESS.toLowerCase();

const checkIsMiningExpress = address => address === process.env.REACT_APP_MINING_EXPRESS_ADDRESS.toLowerCase();

export const getAddressName = address =>
  checkIsExchange(address) ? addresses.eexExchange : checkIsMiningExpress(address) ? addresses.miningExpress : address;
